<template>
  <section id="WinForm" class="win-form" :class="{'visible':!isTransitioning}">
    <div class="content-general">
      <div class="step-num">Step 02</div>
      <h2>Submit Your Info</h2>
      <p>Just for signing up, you get one entry into our grand prize drawing. Submit your information to start the challenge or to let us know how to contact you if you win!</p>
      <form @submit.prevent="submitForm" :class="['form', {'loading': isLoading}]">
        <div class="form-row">
          <div class="form-group checkbox centered" >
            <input id="challenge-signup" name="challenge-signup" type="checkbox" v-model="user.subscribeChallenge">
            <label class="checkbox-label" for="challenge-signup"><span> Send me weekly challenge emails</span></label>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group" :class="{error: readyToValidate && !user.firstName}">
            <input id="first-name" name="first-name" type="text" placeholder="*First Name" @change="validateForm" v-model="user.firstName" tabindex="1">
          </div>
          <div class="form-group"  :class="{error: readyToValidate && !user.lastName}">
            <input id="last-name" name="last-name" type="text" placeholder="*Last Name" @change="validateForm" v-model="user.lastName" tabindex="2">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group" :class="{error: readyToValidate && (!user.email || !validateEmail(user.email))}">
            <input id="email" name="email" type="text" placeholder="*Email Address" @change="validateForm" v-model="user.email" tabindex="3">
          </div>
          <div class="form-group" :class="{error: readyToValidate && !user.phone}">
            <input id="phone" name="phone" type="text" placeholder="*Phone Number" @change="validateForm" v-model="user.phone" tabindex="4">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group" :class="{error: readyToValidate && !user.address}">
            <input id="address" name="address" type="text" placeholder="*Address" @change="validateForm" v-model="user.address" tabindex="5">
          </div>
          <div class="form-group" :class="{error: readyToValidate && !user.city}">
            <input id="city" name="city" type="text" placeholder="*City" @change="validateForm" v-model="user.city" tabindex="6">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group" :class="{error: readyToValidate && !user.state}">
            <div class="city-select-wrapper">
              <select id="state" class="city-select" v-model="user.state" tabindex="7" placeholder="state">
                <option v-for="(state, index) in states" :key="index" :value="state">{{state}}</option>
              </select>
              <div class="fake-city-select">
                <span v-if="user.state" class="fake-selected-state">{{user.state}}</span>
                <span v-if="!user.state" class="fake-placeholder">*State</span>
              </div>
            </div>
          </div>
          <div class="form-group" :class="{error: readyToValidate && (!user.zip || !validateZip(user.zip))}">
            <input id="zip" name="zip" type="text" placeholder="*Zip Code" @change="validateForm" v-model="user.zip" tabindex="8">
          </div>
        </div>
        <div class="form-row">
          <div class="form-group checkbox" :class="{error: readyToValidate && !user.agreeRules}" >
            <input id="agree-to-terms" name="agree-to-terms" type="checkbox" @change="validateForm" v-model="user.agreeRules" tabindex="9">
            <label class="checkbox-label" for="agree-to-terms"><span> I agree to the <a class="rules-link" @click.prevent="openModal('rules')">Official Rules</a></span></label>
          </div>
          <div class="form-group checkbox">
            <input id="agree-to-contact" name="agree-to-contact" type="checkbox" v-model="user.agreeContact" tabindex="10">
            <label class="checkbox-label" for="agree-to-contact"><span> Keep me up-to-date with Zespri Kiwifruit emails</span></label>
          </div>
        </div>
        <div class="form-row submit">
          <button id="submit" class="btn submit-button">Submit to Enter</button>
          <div class="error-message" v-if="this.readyToValidate && !this.formValid" v-html="this.message"></div>
          <p class="recaptcha-disclaimer">This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and
            <a href="https://policies.google.com/terms">Terms of Service</a> apply.
          </p>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import store from '../store'
import axios from 'axios'

export default{
  name: 'win-form',
  data(){
    return {
      user:{
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        agreeRules: false,
        agreeContact: false,
        subscribeChallenge: true
      },
      readyToValidate: false,
      formValid: false,
      isLoading: false,
      message: '',
      states: ['AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS',
        'KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND',
        'OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'],
      isStateDropdownOpen: false
    }
  },
  computed: {
    isTransitioning() {
      return store.state.isTransitioning
    },
    hasErrors(){
      return this.readyToValidate && this.formValid 
    }
  },
  mounted() {
    const _this = this
    setTimeout(function(){
      _this.$emit('sectionHeightChange')
    }, 500)
  },
  methods:{
    openModal(whichModal) {
      store.commit('openModal', whichModal)
    },
    validateForm(){
      this.formValid = true
      this.message = ''
      for (const key in this.user) {
        // agreeing to be contacted is not required
        if (this.user.hasOwnProperty(key) && key !== 'agreeContact' && key !== 'subscribeChallenge') {
          if(!this.user[key]){
            this.formValid = false
            this.message = 'All fields are required. <br />'
          }
        }
      }

      if(!this.validateEmail(this.user.email)){
        this.formValid = false
        this.message += 'The email you entered is invalid.<br />'
      }

      if(!this.validateZip(this.user.zip)){
        this.formValid = false
        this.message += 'The zip you entered is invalid.<br />'
      }
    },

    submitForm(){
      this.readyToValidate = true
      this.validateForm()
      if(this.formValid){
        this.recaptcha()
      }
    },

    addNewUser(){
      store.commit('showLoader')
      axios.post(`${store.state.backendUrl}/addUser`, this.user).then(resp => {
        this.isLoading = false
        this.$cookies.set('user', resp.data, -1)
        this.goToThankYouPage()
      }).catch((err) => {
        this.formValid = false
        this.isLoading = false
        this.message = err.response.data === 'user already signed up'? 'That email address has already been used to sign up.':'There was an error signing you up. Please try again later.'
        console.log(err.response)
      }).finally(() => {
        store.commit('hideLoader')
      })
    },

    recaptcha() {
      this.$recaptcha('signup').then((token) => {
        this.user.recaptcha = token
        this.addNewUser()
      }).catch(err => {
        console.log(err)
        this.message = 'There was an error signing you up. Please try again later.'
      })
    },

    validateZip(zipCode){
      return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipCode)
    },

    validateEmail(emailAddr){
      return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(emailAddr)
    },

    setState(state) {
      this.$nextTick(function () {
        this.user.state = state
      })
    },

    goToThankYouPage() {
      store.commit('goToWinThanks')
    },

    onClickOutside() {
      this.isStateDropdownOpen = false
    }
  }
}
</script>

<style scoped lang="scss">
/** split-container **/
@import '../theme';

.error-message{
  color: red;
  margin: 0 0 30px 0;
}

.win-form {
  position: relative;
  overflow: hidden;
  opacity: 0;
  transform: translateX(100%);
  z-index: zespri-layer(normal);
  transition: all .5s;
  
  .content-general {
    max-width: 630px;
    margin: 50px auto 50px;
    transition: opacity .5s;
    
    @include media-breakpoint-up(md) {
      margin: 0 auto 50px;
    }
  }
  
  &.visible {
    transform: translateX(0);
    opacity: 1;
  }
}

.step-num {
  @include zespri-mid-title;
}

.form {
  display: block;
  margin-top: 35px;
}

.form-row {
  display: flex;
  flex-direction: column;

  @include media-breakpoint-up(md) {
    flex-direction: row;
    margin-bottom: 10px;
  }

  &.submit {
    @include media-breakpoint-up(md) {
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
}

.form-group {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  text-align: left;
  margin-bottom: 25px;
  @include clearfix;
  width: 100%;

  @include media-breakpoint-up(md) {
    width: 50%;
    margin-bottom: 15px;

    &:first-child {
      margin-right: 10px;
    }

    &:last-child {
      margin-left: 10px;
    }
  }

  &.checkbox {
    margin-bottom: 10px;
    @include media-breakpoint-up(md) {
      margin-bottom: 10px;
    }
  }
}

.form-group.centered{
  margin-left: auto;
  margin-right: auto;
}

.form-group-sub {
  width: 45%;
  float: left;
  &+.form-group-sub{
    margin-left: 10%;
  }
}

label {
  display: inline-block;
  margin-bottom: 13px;
}

label a{
  text-decoration: underline;
  cursor: pointer;
}

.error {
  input[type=text]{
    border-color: red;
  }

  input[type=checkbox]{
    + label {
      &:before {
        border-color: red;
      }
    }
  }

  label {
    color: red;
  }

  .fake-city-select {
    border-color: red;
  }
}

input[type=text] {
  @include zespri-button-text;
  padding: 8px 10px;
  background: zespri-brand-color(off-white);
  border: none;
  border: 2px solid zespri-brand-color(dark-green);
  border-radius: 5px;
  display: block;
  width: 100%;
  color: zespri-brand-color(dark-green);
  transition: border-color .2s;

  &:focus {
    outline: none;
    border-color: zespri-brand-color(green);
  }
}

input[type=checkbox] {
  position: absolute;
  left: -999999px;
  $label-hw: 15px;

  + label {
    @include noselect;
    padding-top: 2px;
    padding-left: $label-hw + 10;
    position: relative;

    &:before {
      content: '';
      border: 2px solid zespri-brand-color(dark-green);
      border-radius: 5px;
      display: block;
      height: $label-hw;
      position: absolute;
      top: 0;
      left: 0;
      width: $label-hw;
      transition: background-color .2s;
    }
  }

  &:checked {
    + label:before {
      background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 30 30' style='enable-background:new 0 0 30 30;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFCC00;%7D%0A%3C/style%3E%3Ctitle%3Echeck%3C/title%3E%3Cpath class='st0' d='M21.9,12.4c0.7-0.8,0.7-2,0-2.8c-0.7-0.7-1.9-0.8-2.6,0c0,0,0,0,0,0L13,16l-2.3-2.3c-0.7-0.7-1.9-0.8-2.6,0 c0,0,0,0,0,0c-0.7,0.8-0.7,2,0,2.8l4,4.1c0.5,0.5,1.4,0.6,1.9,0c0,0,0,0,0,0L21.9,12.4z'/%3E%3C/svg%3E");
      background-color: zespri-brand-color(dark-green);
      background-size: 120%;
      background-position: 35% 40%;
    }
  }
}

.submit-button {
  @include cta-button-large(zespri-brand-color(white), zespri-brand-color(dark-green), zespri-brand-color(green));
  margin: 0 0 30px 0;
}

.city-select-wrapper {
  position: relative;
  width: 100%;
}

.city-select {
  position: relative;
  z-index: 9;
  height: 34px;
  width: 100%;
  border-radius: 5px;

  &:focus {
    outline: 0;
    border: 0;

    + .fake-city-select {
      border-color: zespri-brand-color(green);
    }
  }
}

.fake-city-select {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  cursor: pointer;
  box-sizing: border-box;
  border: 2px solid zespri-brand-color(dark-green);
  border-radius: 5px;
  background: zespri-brand-color(off-white);
  outline: none;
  color: zespri-brand-color(dark-green);
  text-align: left;
  transition: all .2s;
  pointer-events: none;
  padding: 5px 10px;

  &:after {
    content: "";
    position: absolute;
    right: 12px;
    top: 12px;
    display: inline-block;
    width: 16px;
    height: 8px;
    border: 0;
    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='22px' height='13px' viewBox='0 0 22 13' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round'%3E%3Cg transform='translate%28-724.000000, -167.000000%29' stroke-width='2' stroke='%23D1D1D1'%3E%3Cg id='dropdown' transform='translate%28377.000000, 148.000000%29'%3E%3Cpolyline id='Path-3' transform='translate%28358.000000, 25.000000%29 rotate%2890.000000%29 translate%28-358.000000, -25.000000%29 ' points='353 15 363 24.8984656 353 35'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: 16px 8px;
    transition: all .2s;
  }

  .fake-selected-state, .fake-placeholder {
    @include zespri-button-text;
  }
  .fake-selected-state {
    color: zespri-brand-color(dark-green);
  }
  .fake-placeholder {
    color: #777;
  }
}

</style>
